import { Component, Input } from '@angular/core';

/**
 * A component that renders an SVG icon for "Check All"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-check-all',
    templateUrl: './icon-check-all.component.html',
    styleUrls: ['./icon-check-all.component.scss'],
    standalone: false
})
export class IconCheckAllComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
